import { Grid, SxProps, Theme } from "@mui/material";
import SelectClientDashboardMenu from "../../../modules/dashboard/components/SelectedClientDashboardMenu";
import SelectUsinaDashboardMenu from "../../../modules/dashboard/components/SelectUsinaDashboardMenu";

type ScreenHeaderProps = {
  children: React.ReactNode;
  sx?: SxProps<Theme>;
  hasUsinaSelect?: boolean;
};

export function ScreenHeader({
  children,
  sx,
  hasUsinaSelect,
}: ScreenHeaderProps) {
  return (
    <Grid
      sx={{
        display: "flex",
        flexDirection: {
          xs: "column",
          sm: "row",
        },
        justifyContent: hasUsinaSelect ? "space-between" : undefined,
        alignItems: "center",
        ...sx,
      }}
      item
      paddingTop={{
        xs: "10px",
        sm: "20px",
      }}
      paddingLeft={{
        xs: "15px",
        sm: "40px",
      }}
      paddingRight={{
        xs: "15px",
        sm: "40px",
      }}
      xs={12}
    >
      {children}

      {hasUsinaSelect && (
        <Grid
          container
          sx={{
            display: "flex",
            marginTop: { xs: 2, sm: "none" },
            maxWidth: "400px",
            flexGrow: 1,
          }}
          spacing={2}
        >
          <>
            <Grid item xs={12} sm={6}>
              <SelectClientDashboardMenu />
            </Grid>
            <Grid item xs={12} sm={6}>
              <SelectUsinaDashboardMenu />
            </Grid>
          </>
        </Grid>
      )}
    </Grid>
  );
}
